@if (participants.length > 0) {
    @for (participant of participants; track participant) {
        <adapt-link-person [person]="participant"
                           [imageOnly]="true"></adapt-link-person>
    }
} @else {
    <p>This meeting has no attendees</p>
}
